let bankTypeOptions = [
  {
    label: '中国工商银行',
    value: '中国工商银行'
  },
  {
    label: '中国农业银行',
    value: '中国农业银行'
  },
  {
    label: '中国银行',
    value: '中国银行'
  },
  {
    label: '中国建设银行',
    value: '中国建设银行'
  },
  {
    label: '中国交通银行',
    value: '中国交通银行'
  },
  {
    label: '中国人民银行',
    value: '中国人民银行'
  },
  {
    label: '兴业银行',
    value: '兴业银行'
  },
  {
    label: '招商银行',
    value: '招商银行'
  },
  {
    label: '浦发银行',
    value: '浦发银行'
  },
  {
    label: '江苏银行',
    value: '江苏银行'
  },
  {
    label: '华夏银行',
    value: '华夏银行'
  },
  {
    label: '平安银行',
    value: '平安银行'
  },
  {
    label: '中信银行',
    value: '中信银行'
  },
  {
    label: '其它',
    value: '其它'
  }
]

export default bankTypeOptions



// WEBPACK FOOTER //
// ./src/utils/bankTypeOptions.js